export const isValidPriceFormat = (value: string): boolean => {
  return value === '' || /^\d*\.?\d{0,2}$/.test(value)
}
